module.exports = __webpack_public_path__ + "static/media/qr-code-telegram.79c1ed06.svg";